import { BlockData } from '@bw/apis/contentful';
import { FC } from 'react';
import { defined } from '../utils/defined';
import { BlockMap, RenderFunction } from './types';

type Props = {
	data: BlockData | BlockData[];
	blockMap: BlockMap;
	context?: object;
};

export const BlockFactory: FC<Props> = (rootProps) => {
	const fieldId = () => ({});
	const render: RenderFunction = (
		data?: BlockData | (BlockData | undefined)[],
		context?: object, // TODO(khaney): make this type safe
	) => {
		data = Array.isArray(data) ? data : [data];

		return (
			<>
				{defined(data)
					.map((componentData, index) => {
						// TODO(khaney): make this type safe
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						const Block = rootProps.blockMap[
							componentData.sys.contentType.sys.id
						] as any;

						if (!Block) {
							console.error(
								`BlockFactory: No block found for content type ${componentData.sys.contentType.sys.id}`
							);
							return null;
						}

						return (
							<Block
								key={componentData.sys.id}
								data={componentData}
								{...{ fieldId, render, index, context }}
							/>
						);
					})}
			</>
		);
	};

	return render(rootProps.data, rootProps.context);
};
